import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, memo, Suspense } from "react";
import clsx from "clsx";
import { PaymentPlan, PendingButton } from "@ploy-ui/core";
import { useServiceHandler } from "../../hooks";
import { Typography, CircularProgress } from "@material-ui/core";
import { useVariableData } from "@ploy-lib/calculation";
import { makeStyles } from "@material-ui/core/styles";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { defineMessages, useIntl } from "react-intl";
const useStyles = makeStyles({
    root: {
        textAlign: "center",
        "&&": {
            maxWidth: "100%"
        }
    },
    overlayProgress: {
        width: "100%",
        zIndex: 1000
    },
    title: {
        margin: "30px auto",
        fontSize: "2.375rem",
        fontWeight: 700,
        lineHeight: 1.32,
        letterSpacing: "-.03rem",
        textAlign: "left"
    }
}, { name: "DployPaymentPlanSection" });
addRegisteredSectionLayout({
    name: "PaymentPlanSection",
    displayName: "PaymentPlanSection",
    settings: {
        editableOptions: {
            minimized: true
        }
    }
});
const messages = defineMessages({
    print: {
        id: "ploy-ui.template-form.paymentplansection.button.print",
        description: "Print button",
        defaultMessage: "Print"
    },
    error: {
        id: "ploy-ui.template-form.paymentplansection.error",
        description: "Errormessage for paymentplan error",
        defaultMessage: "An error occured"
    }
});
const PaymentPlanSectionInner = memo((props) => {
    const { className, onClick, sectionTitle, minimized } = props;
    const intl = useIntl();
    const classes = useStyles(props);
    // Figure out a way to configure this, if necessary
    const service = {
        namespace: "Calculator",
        service: "CalculatePaymentPlan"
    };
    const conditionsResult = useVariableData("Calculator", "service_Conditions_result");
    const [handler, pending, result] = useServiceHandler(service);
    useEffect(() => {
        if (typeof handler === "function")
            handler();
    }, [handler, conditionsResult]);
    const { payments = [] } = result && result.data && result.data.payments
        ? result.data
        : { payments: [] };
    return (_jsxs("div", { className: clsx(classes.root, className), onClick: onClick, children: [pending && (_jsx(CircularProgress, { className: classes.overlayProgress }, "pending")), _jsxs(Suspense, { fallback: pending ? null : (_jsx(CircularProgress, { className: classes.overlayProgress }, "pending")), children: [!pending && sectionTitle && (_jsx(Typography, { className: classes.title, children: sectionTitle })), _jsx(PaymentPlan, { payments: payments, minimized: minimized, settings: result?.data?.settings }), !pending && !minimized && payments.length > 0 && (_jsx("div", { style: { marginTop: 10, float: "right" }, children: _jsx(PendingButton, { onClick: () => {
                                window.open(window.location.origin +
                                    "/PrintView?view=PaymentPlan%3FSesInstName=", "_blank");
                            }, variant: "contained", color: "primary", children: intl.formatMessage(messages.print) }) }))] }), !pending && payments.length <= 0 && (_jsx(Typography, { color: "error", className: props.className, children: intl.formatMessage(messages.error) }))] }));
});
PaymentPlanSectionInner.displayName = "DployPaymentPlanSection";
const PaymentPlanSection = memo((props) => {
    const { expanded } = props;
    if (!expanded)
        return null;
    return _jsx(PaymentPlanSectionInner, { ...props });
});
PaymentPlanSection.displayName = "DployPaymentPlanSection";
export { PaymentPlanSection };
//# sourceMappingURL=PaymentPlanSection.js.map